<template>
  <b-row>
    <b-col cols="10">
      <b-input-group size="sm">
        <b-form-input type="number" v-model="scale.maxCost"/>
        <b-form-input type="number" v-model="scale.profitMin"/>
        <b-form-input type="number" v-model="scale.profitMax"/>
        <b-form-input type="number" v-model="scale.profitFix"/>
      </b-input-group>
    </b-col>
    <b-col cols="1">
      <b-button variant="danger" size="sm" @click="deleteScale(index)">
        <feather-icon icon="MinusCircleIcon"/>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {BRow, BCol, BInputGroup, BFormInput} from "bootstrap-vue";

export default {
  name: "Scale",
  components: {BRow, BCol, BInputGroup, BFormInput},
  props: {
    index: {
      type: Number,
      required: true
    },
    storeId: {
      type: Number,
      required: true
    },
    scale: {
      type: Object,
      required: true
    },
    page: {
      type: String,
      default: ''
    }
  },
  methods: {
    deleteScale(index) {
      if(this.page === 'afn') {
        this.$store.commit('store/deleteAfnScale', {storeId: this.storeId, indexNo: index})
        return
      }
      this.$store.commit('store/deleteScale', {storeId: this.storeId, indexNo: index})
    }
  }
}
</script>

<style scoped>

</style>
